export const MANUAL_MEAL_MAX_ENTRIES = 50;

/** Grams a picked product without a serving is scaled to before the user adjusts the amount. */
export const DEFAULT_PRODUCT_QUANTITY_GRAMS = 100;

/** Servings a picked product with a serving starts at. */
export const DEFAULT_PRODUCT_SERVING_QUANTITY = 1;
